import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyC6VcNvhdMV32bt1ijxBqMNrpxx7eRlCw8',
  authDomain: 'lagking.firebaseapp.com',
  projectId: 'lagking',
  storageBucket: 'lagking.firebasestorage.app',
  messagingSenderId: '434560618193',
  appId: '1:434560618193:web:e18ad1745a199bbe9b7ff0',
};

const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
export const functions = getFunctions(app, 'us-east1');
